import SidebarValue from './SidebarValue.tsx';

export default SidebarValue;
